module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group form-group--three-columns"
  }, _vm._l((_vm.coindistributionsetting), function(item, index) {
    return _c('div', {
      staticClass: "form-row"
    }, [_c('p', {
      staticClass: "coin-text"
    }, [_vm._v(_vm._s(parseFloat(_vm.coindistributionsetting[index].value / 100).toFixed(2) + " " + _vm.coindistributionsetting[index].currency))]), _vm._v(" "), _c('el-select', {
      attrs: {
        "disabled": !_vm.overridden || _vm.readOnly
      },
      on: {
        "change": function($event) {
          _vm.updateSettings()
        }
      },
      model: {
        value: (_vm.coindistributionsetting[index].location),
        callback: function($$v) {
          _vm.$set(_vm.coindistributionsetting[index], "location", $$v)
        },
        expression: "coindistributionsetting[index].location"
      }
    }, [_c('el-option', {
      attrs: {
        "value": 1
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": 2
      }
    })], 1)], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12e39832!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dq-ui/packages/coindistributionpanel/src/coindistributionpanel.vue
// module id = 486
// module chunks = 36